import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { Heading, Reviews } from '../../components';

import ExpandableSection from './ExpandableSection';
import ReviewForm from '../TransactionPage/ReviewForm/ReviewForm';
import css from './ListingPage.module.css';

const SectionReviews = props => {
  const {
    currentUser,
    isOwnListing,
    reviews,
    fetchReviewsInProgress,
    fetchReviewsError,
    sendReviewInProgress,
    sendReviewError,
    reviewSubmitted,
    onSendReview,
    intl,
  } = props;

  const renderReviewsContent = () => {
    if (fetchReviewsInProgress || fetchReviewsError) {
      return null;
    }

    return reviews.length === 0 ? (
      <p className={css.noReviews}>
        <FormattedMessage id="ListingPage.noReviews" />
      </p>
    ) : (
      <Reviews className={css.reviews} reviews={reviews} />
    );
  };

  // Show review form if the current user is not the user whose profile is being viewed
  const showReviewForm = currentUser && !isOwnListing;
  const reviewForm = showReviewForm ? (
    <ReviewForm
      sendReviewInProgress={sendReviewInProgress}
      sendReviewError={sendReviewError}
      reviewSent={reviewSubmitted}
      onSubmit={onSendReview}
    />
  ) : null;

  return (
    <ExpandableSection
      className={css.sectionReviews}
      id="reviews"
      title={intl.formatMessage(
        { id: 'ListingPage.reviewsTitle' },
        { count: Array.isArray(reviews) ? reviews.length : 0 }
      )}
    >
      <div className={css.reviewsContainer}>
        {reviewForm}
        {renderReviewsContent()}
      </div>
    </ExpandableSection>
  );
};

export default SectionReviews;
